import { useState, useRef } from 'react';
import { useAlert } from '../../contexts/AlertContext';
import { CalendarDaysIcon } from '@heroicons/react/20/solid';
import { Modal } from '../modals/Modal';
import { Button } from '../buttons/Button';
import { optionDateRange } from '../../contexts/DashboardContext';

export const Calendar = ({ useContext, contextType, disabled = false }) => {
  const { showAlert } = useAlert();
  const [calendarStartDate, setCalendarStartDate] = useState('');
  const [calendarStopDate, setCalendarStopDate] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const calendarRef = useRef();

  const context = useContext();
  const { setSelectedDateRange } = context;

  const handleOpenModal = () => {
    if (!disabled) {
      setIsModalOpen(true);
    }
  };

  const handleStartDateChange = (event) => {
    setCalendarStartDate(event.target.value);
  };

  const handleStopDateChange = (event) => {
    setCalendarStopDate(event.target.value);
  };

  const handleDateSubmit = (event) => {
    event.preventDefault();
    const currentDate = new Date();
    const startDate = new Date(calendarStartDate);
    const midnightStartDate = new Date(startDate);
    midnightStartDate.setHours(0, 0, 0, 0);

    const stopDate = new Date(calendarStopDate);
    const endOfDayStopDate = new Date(stopDate);
    endOfDayStopDate.setHours(23, 59, 59, 999);

    if (startDate > stopDate) {
      showAlert('error', 'Oops! The start date cannot be later than the end date.');
      return;
    }

    // if (startDate > currentDate || stopDate > currentDate) {
    //   showAlert('error', 'Oops! Please select a date range that is not in the future.');
    //   return;
    // }

    if (contextType === 'journal') {
      setSelectedDateRange({ start: midnightStartDate, stop: endOfDayStopDate });
    } else if (contextType === 'dashboard') {
      const customRange = optionDateRange.find((range) => range.name === 'CUSTOM');
      const startDateString = new Date(midnightStartDate).toLocaleString();
      const stopDateString = new Date(endOfDayStopDate).toLocaleString();

      const startTimestamp = new Date(midnightStartDate).getTime() / 1000;
      const endTimestamp = new Date(endOfDayStopDate).getTime() / 1000;
      const durationInMilliseconds = ((endTimestamp - startTimestamp) * 1000 * 2) / 3;

      const newSelectedDateRange = {
        ...customRange,
        vs_string: `${startDateString} - ${stopDateString}`,
        start: midnightStartDate,
        stop: endOfDayStopDate,
        value: durationInMilliseconds,
      };
      setSelectedDateRange(newSelectedDateRange);
    }
    setIsModalOpen(false);
  };

  const isDateError = (calendarStartDate === '' || calendarStopDate === '' || (new Date(calendarStartDate)) > (new Date(calendarStopDate)));

  return (
    <>
      <button onClick={handleOpenModal} className={disabled ? 'pointer-events-none' : ''}>
        <CalendarDaysIcon
          className={`w-6 h-6 ml-2 mr-2 ${disabled ? 'text-perception-gray-800' : 'text-perception-gray-500'}   hover:text-perception-gray-200`}
        />
      </button>

      <Modal isOpen={isModalOpen} setIsOpen={setIsModalOpen} size="medium">
        <h3 className="mb-4 text-lg font-medium">Select date range</h3>
        <form onSubmit={handleDateSubmit} ref={calendarRef}>
          <label className="flex flex-col gap-1">
            <span className="text-gray-700">Start date</span>
            <input
              type='date'
              value={calendarStartDate}
              onChange={handleStartDateChange}
              required
              className="px-4 py-2 outline-0 rounded-md bg-gray-100 w-96"
            />
          </label>
          <label className="flex flex-col gap-1 my-4">
            <span className="text-gray-700">End date</span>
            <input
              type='date'
              value={calendarStopDate}
              onChange={handleStopDateChange}
              required
              className="px-4 py-2 outline-0 rounded-md bg-gray-100 w-96"
            />
          </label>
          <div>
            {
              calendarStartDate !== '' && calendarStopDate !== '' && isDateError &&
                <p className="text-perception-error-500 text-sm mb-4">The start date cannot be later than the end date.</p>
            }
            <Button type='submit' category='tertiary-btn' className="rounded-md" disabled={isDateError}>
              Submit
            </Button>
          </div>
        </form>
      </Modal>
    </>
  );
};
